<template>
  <core-popup
    show
    :title="locales('settings_popup_delete_title')"
    :close-icon="true"
    width="440"
    @onClickCancel="$emit('onClose')"
  >
    <template #body>
      <div :class="$style.column_delete_popup">
        <div
          v-if="columnProjects.archive || columnProjects.visible"
          :class="$style.column_delete_warning"
        >
          <sprite
            :name="'warning-1'"
            :type="'bold'"
            :size="20"
            :color="'#FF9A00'"
          />

          <div :class="$style.warning_message_text">
            <p v-if="columnProjects.visible">
              {{ locales('columns_projects_number', { number: columnProjects.visible }) }}
            </p>

            <p v-if="columnProjects.archive">
              {{ locales('columns_archive_projects_number', { number: columnProjects.archive }) }}
            </p>
          </div>
        </div>

        <div
          :class="$style.delete_column_message"
          v-html="locales('settings_popup_delete_message', { name: columnName })"
        />

        <vgp-input
          v-model="inputConfirmValue"
          :small="true"
          :placeholder="locales('settings_popup_delete_placeholder')"
          :border="true"
        />

        <div :class="$style.buttons">
          <vgp-button
            type="secondary"
            :label="locales('common_cancel')"
            :small="true"
            @onClick="$emit('onClose')"
          />
          <vgp-button
            :style="{ marginLeft: 16 + 'px' }"
            type="destructive"
            :label="locales('common_delete')"
            :small="true"
            :disabled="disabledConfirm"
            @onClick="onConfirm"
          />
        </div>
      </div>
    </template>
  </core-popup>
</template>

<script>
import corePopup from '$$vueCmp/popups/corePopup/corePopup.vue';
import vgpButton from '$$vueCmp//globalButton/vgpButton.vue';
import vgpInput from '$$vueCmp/vInput/vgpInput.vue';
import sprite from '$$vueCmp/VueIcon/svgSprite.vue';

export default {
  name: 'ColumnDeletePopup',
  components: {
    corePopup,
    vgpButton,
    vgpInput,
    sprite,
  },
  props: {
    columnId: {
      type: Number,
      required: true,
    },
  },
  emits: {
    onClose: null,
  },
  data() {
    return {
      locales: __,
      inputConfirmValue: '',
    };
  },
  computed: {
    columnName() {
      const customColumn = this.$store.getters['columns/getCustomColumnById'](this.columnId);
      let customColumnName = customColumn.name;

      if (/[<>]/.test(customColumnName)) {
        customColumnName = customColumnName.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }

      return customColumnName;
    },
    columnProjects() {
      return this.$store.getters['columns/getProjectsNumberByColumnId'](this.columnId);
    },
    disabledConfirm() {
      return this.inputConfirmValue !== this.columnName;
    },
  },
  methods: {
    onConfirm() {
      this.$store.dispatch('columns/removeColumn', this.columnId);
      this.$emit('onClose');
    },
  },
};
</script>

<style module src="../less/columnDeletePopup.less"></style>
